import styles from './Layout.module.css';

type Props = {
  children: React.ReactNode;
};

export default function Layout(props: Props) {
  return <div className={styles['layout']}>{props.children}</div>;
}
